const timeLimits = [
  { value: null, label: "None", scoreBonus: 0 },
  { value: 20, label: "20s", scoreBonus: 25 },
  { value: 15, label: "15s", scoreBonus: 50 },
  { value: 10, label: "10s", scoreBonus: 75 },
  { value: 5, label: "5s", scoreBonus: 100 },
];

export default timeLimits;
